module.exports = __webpack_public_path__ + "img/fmoh_logo.7630de64.png";